(function (window, document) {
  'use strict';

  if (window.ESSavedPrescriptions) return;

  var CONFIG = window.ES_SAVED_RX_CONFIG || {};
  var ALLOWED_TYPES = ['single_vision', 'progressive', 'bifocal', 'readers'];
  var ALLOWED_METHODS = ['manual', 'upload'];
  var TYPE_LABELS = {
    single_vision: 'Single Vision',
    progressive: 'Progressives (No Line)',
    bifocal: 'Bifocal (Visible Line)',
    readers: 'Readers'
  };
  var PENDING_KEY = 'es_saved_rx_handoff_v1';
  var ACCESS_KEY = 'es_saved_rx_storefront_access_v1';
  var pendingCache = null;
  var accessCache = null;
  var redeemPromise = null;
  var listPromise = null;
  var listCache = null;
  var listCacheAt = 0;
  var LIST_CACHE_MS = 60 * 1000;

  function trim(value) {
    return String(value == null ? '' : value).trim();
  }

  function isEnabled() {
    return CONFIG.enabled === true || CONFIG.enabled === 'true' || CONFIG.enabled === 1 || CONFIG.enabled === '1';
  }

  function accountPageUrl() {
    return trim(CONFIG.accountPageUrl || '');
  }

  function proxyBase() {
    return trim(CONFIG.proxyPath || '/apps/eyeshells-prescriptions').replace(/\/+$/, '');
  }

  function uid() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return 'rx_' + window.crypto.randomUUID().replace(/-/g, '');
      if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
        var bytes = new Uint8Array(12);
        window.crypto.getRandomValues(bytes);
        return 'rx_' + Array.prototype.map.call(bytes, function (byte) {
          return byte.toString(16).padStart(2, '0');
        }).join('');
      }
    } catch (error) {}
    return 'rx_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
  }

  function formatSignedNumber(value, fallback) {
    var raw = trim(value);
    if (!raw || raw.toLowerCase() === 'choose') return fallback == null ? '' : fallback;
    var number = Number(raw);
    if (!isFinite(number)) return fallback == null ? '' : fallback;
    if (Math.abs(number) < 0.0001) return '0.00';
    return (number > 0 ? '+' : '') + number.toFixed(2);
  }

  function formatAxis(value) {
    var raw = trim(value);
    if (!raw || raw.toLowerCase() === 'choose') return '';
    var number = Math.round(Number(raw));
    if (!isFinite(number) || number < 1 || number > 180) return '';
    return String(number).padStart(3, '0');
  }

  function formatPd(value, decimals) {
    var raw = trim(value);
    if (!raw || raw.toLowerCase() === 'choose') return '';
    var number = Number(raw);
    if (!isFinite(number)) return '';
    return decimals ? number.toFixed(1) : String(Math.round(number));
  }

  function normalizeEye(value) {
    var eye = value && typeof value === 'object' ? value : {};
    var cyl = formatSignedNumber(eye.cyl, '0.00');
    return {
      sph: formatSignedNumber(eye.sph, '0.00'),
      cyl: cyl,
      axis: cyl === '0.00' ? '' : formatAxis(eye.axis)
    };
  }

  function formatPrismPower(value) {
    var raw = trim(value);
    if (!raw || raw.toLowerCase() === 'choose') return '0.00';
    var number = Number(raw);
    if (!isFinite(number) || number < 0 || number > 5 || Math.abs(number * 4 - Math.round(number * 4)) > 0.0001) return '0.00';
    return number.toFixed(2);
  }

  function normalizePrismEye(value) {
    var input = value && typeof value === 'object' ? value : {};
    var horizontal = formatPrismPower(input.horizontal);
    var vertical = formatPrismPower(input.vertical);
    var horizontalBase = trim(input.horizontalBase).toUpperCase();
    var verticalBase = trim(input.verticalBase).toUpperCase();
    return {
      horizontal: horizontal,
      horizontalBase: horizontal !== '0.00' && (horizontalBase === 'IN' || horizontalBase === 'OUT') ? horizontalBase : '',
      vertical: vertical,
      verticalBase: vertical !== '0.00' && (verticalBase === 'UP' || verticalBase === 'DOWN') ? verticalBase : ''
    };
  }

  function normalizePrism(value, type, method) {
    var input = value && typeof value === 'object' ? value : {};
    var enabled = type === 'single_vision' && (input.enabled === true || input.enabled === 'true' || input.enabled === 1 || input.enabled === '1');
    if (!enabled) return { enabled: false, od: normalizePrismEye(null), os: normalizePrismEye(null) };
    if (method === 'upload') return { enabled: true, od: normalizePrismEye(null), os: normalizePrismEye(null) };
    return { enabled: true, od: normalizePrismEye(input.od), os: normalizePrismEye(input.os) };
  }

  function normalizeFile(value) {
    var input = value && typeof value === 'object' ? value : {};
    var key = trim(input.key);
    var name = trim(input.name).slice(0, 180);
    var mimeType = trim(input.mimeType).toLowerCase().slice(0, 100);
    var size = Math.max(0, Math.round(Number(input.size || 0)) || 0);
    if (!key || !name || !mimeType || !size) return null;
    return {
      key: key,
      name: name,
      mimeType: mimeType,
      size: size,
      uploadedAt: trim(input.uploadedAt),
      etag: trim(input.etag)
    };
  }


  function normalizeOrderFile(value) {
    var input = value && typeof value === 'object' ? value : {};
    var id = trim(input.id);
    var name = trim(input.name).slice(0, 180);
    var mimeType = trim(input.mimeType).toLowerCase().slice(0, 100);
    var size = Math.max(0, Math.round(Number(input.size || 0)) || 0);
    var viewUrl = trim(input.viewUrl).slice(0, 2000);
    var claimToken = trim(input.claimToken).slice(0, 180);
    var deleteToken = trim(input.deleteToken).slice(0, 180);
    if (!/^rxu_[A-Za-z0-9_-]{30,120}$/.test(id) || !name || !mimeType || !size || !/^https:\/\//i.test(viewUrl)) return null;
    return {
      id: id,
      name: name,
      mimeType: mimeType,
      size: size,
      uploadedAt: trim(input.uploadedAt),
      status: trim(input.status) === 'cart' ? 'cart' : 'pending',
      source: trim(input.source) === 'saved_prescription' ? 'saved_prescription' : 'lens_builder',
      viewUrl: viewUrl,
      claimToken: claimToken,
      deleteToken: deleteToken
    };
  }

  function parseJsonResponse(response, fallbackMessage) {
    return response.text().then(function (text) {
      var payload = {};
      try { payload = text ? JSON.parse(text) : {}; } catch (error) {}
      if (!response.ok) {
        var requestError = new Error(payload.error || fallbackMessage || 'The request could not be completed.');
        requestError.status = response.status;
        requestError.details = payload.details;
        throw requestError;
      }
      return payload;
    });
  }

  function uploadOrderFile(file) {
    if (!(file instanceof Blob)) return Promise.reject(new Error('Choose a prescription file.'));
    var form = new FormData();
    form.append('file', file, file.name || 'prescription');
    return fetch(proxyBase() + '/v3/order-files/upload', {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
      body: form
    }).then(function (response) {
      return parseJsonResponse(response, 'The prescription file could not be stored securely.');
    }).then(function (payload) {
      var normalized = normalizeOrderFile(payload);
      if (!normalized) throw new Error('The private prescription file response was invalid.');
      return normalized;
    });
  }

  function createOrderFileFromSaved(profile) {
    var saved = normalizeProfile(profile);
    if (!saved || saved.method !== 'upload' || !saved.id) return Promise.reject(new Error('The saved prescription file is unavailable.'));
    if (saved.orderFile) return Promise.resolve(saved.orderFile);
    return fetch(withStorefrontAccess(proxyBase() + '/v3/order-files/from-saved'), {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ prescriptionId: saved.id })
    }).then(function (response) {
      return parseJsonResponse(response, 'The saved prescription could not be prepared for this order.');
    }).then(function (payload) {
      var normalized = normalizeOrderFile(payload);
      if (!normalized) throw new Error('The private prescription file response was invalid.');
      return normalized;
    });
  }

  function claimOrderFile(orderFile) {
    var file = normalizeOrderFile(orderFile);
    if (!file || !file.claimToken) return Promise.resolve(file);
    return fetch(proxyBase() + '/v3/order-files/claim', {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: file.id, claimToken: file.claimToken })
    }).then(function (response) {
      return parseJsonResponse(response, 'The private prescription file could not be attached to the cart.');
    }).then(function (payload) {
      return normalizeOrderFile(payload) || file;
    });
  }

  function deleteOrderFile(orderFile) {
    var file = normalizeOrderFile(orderFile);
    if (!file || !file.deleteToken || file.status === 'cart') return Promise.resolve(false);
    return fetch(proxyBase() + '/v3/order-files/delete', {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: file.id, deleteToken: file.deleteToken })
    }).then(function (response) {
      return parseJsonResponse(response, 'The unused private prescription file could not be removed.');
    }).then(function () { return true; }).catch(function () { return false; });
  }

  function normalizeProfile(value) {
    var input = value && typeof value === 'object' ? value : {};
    var type = ALLOWED_TYPES.indexOf(trim(input.type)) > -1 ? trim(input.type) : 'single_vision';
    var method = type === 'readers' ? 'manual' : (ALLOWED_METHODS.indexOf(trim(input.method)) > -1 ? trim(input.method) : 'manual');
    var pdMode = trim(input.pdMode) === 'dual' ? 'dual' : 'single';
    var prism = normalizePrism(input.prism, type, method);
    var now = new Date().toISOString();
    return {
      id: trim(input.id) || uid(),
      name: trim(input.name).slice(0, 60),
      type: type,
      method: method,
      prescriptionDate: type === 'readers' ? '' : trim(input.prescriptionDate).slice(0, 10),
      renewalMonths: type === 'readers' ? 0 : ([0, 6, 12, 24].indexOf(Number(input.renewalMonths || 0)) > -1 ? Number(input.renewalMonths || 0) : 0),
      birthYear: type === 'readers' ? '' : trim(input.birthYear).slice(0, 4),
      od: type === 'readers' ? { sph: '', cyl: '', axis: '' } : normalizeEye(input.od),
      os: type === 'readers' ? { sph: '', cyl: '', axis: '' } : normalizeEye(input.os),
      add: method === 'manual' && (type === 'progressive' || type === 'bifocal') ? formatSignedNumber(input.add, '') : '',
      readingStrength: type === 'readers' ? formatSignedNumber(input.readingStrength, '') : '',
      prism: prism,
      file: type !== 'readers' && method === 'upload' ? normalizeFile(input.file) : null,
      orderFile: type !== 'readers' && method === 'upload' ? normalizeOrderFile(input.orderFile) : null,
      pdMode: type === 'readers' ? 'single' : pdMode,
      pdSingle: type === 'readers' ? '' : (pdMode === 'single' ? formatPd(input.pdSingle, false) : ''),
      pdRight: type === 'readers' ? '' : (pdMode === 'dual' ? formatPd(input.pdRight, true) : ''),
      pdLeft: type === 'readers' ? '' : (pdMode === 'dual' ? formatPd(input.pdLeft, true) : ''),
      notes: trim(input.notes).slice(0, 500),
      isDefault: input.isDefault === true || input.isDefault === 'true' || input.isDefault === 1 || input.isDefault === '1',
      createdAt: trim(input.createdAt) || now,
      updatedAt: trim(input.updatedAt) || now
    };
  }

  function validateProfile(profile) {
    var errors = {};
    if (!profile || typeof profile !== 'object') return { profile: 'Prescription data is unavailable.' };
    if (!profile.name) errors.name = 'Prescription name is missing.';
    if (ALLOWED_TYPES.indexOf(profile.type) === -1) errors.type = 'Prescription type is invalid.';
    if (ALLOWED_METHODS.indexOf(profile.method) === -1) errors.method = 'Prescription method is invalid.';
    if (profile.type === 'readers') {
      var readingPower = Number(profile.readingStrength);
      if (!isFinite(readingPower) || readingPower < 0.25 || readingPower > 3.75 || Math.abs(readingPower * 4 - Math.round(readingPower * 4)) > 0.0001) errors.readingStrength = 'Reading power is invalid.';
    } else {
      if (profile.method === 'upload') {
        if (!normalizeFile(profile.file)) errors.file = 'Uploaded prescription file is missing.';
      } else {
        ['od', 'os'].forEach(function (eyeKey) {
          var eye = profile[eyeKey] || {};
          var sph = Number(eye.sph);
          var cyl = Number(eye.cyl);
          if (!isFinite(sph) || sph < -20 || sph > 12) errors[eyeKey + 'Sph'] = 'SPH is invalid.';
          if (!isFinite(cyl) || cyl < -6 || cyl > 6) errors[eyeKey + 'Cyl'] = 'CYL is invalid.';
          if (Math.abs(cyl) > 0.0001 && (!eye.axis || Number(eye.axis) < 1 || Number(eye.axis) > 180)) errors[eyeKey + 'Axis'] = 'Axis is invalid.';
        });
        if ((profile.type === 'progressive' || profile.type === 'bifocal') && !profile.add) errors.add = 'ADD is missing.';
      }
      if (profile.type === 'single_vision' && profile.prism && profile.prism.enabled && profile.method === 'manual') {
        var hasPrismValue = false;
        ['od', 'os'].forEach(function (eyeKey) {
          var prismEye = profile.prism[eyeKey] || {};
          [['horizontal', 'horizontalBase', ['IN', 'OUT']], ['vertical', 'verticalBase', ['UP', 'DOWN']]].forEach(function (row) {
            var power = Number(prismEye[row[0]] || 0);
            if (power > 0) {
              hasPrismValue = true;
              if (row[2].indexOf(trim(prismEye[row[1]]).toUpperCase()) === -1) errors['prism' + eyeKey + row[1]] = 'Prism base direction is invalid.';
            }
          });
        });
        if (!hasPrismValue) errors.prism = 'At least one prism value is required.';
      }
      if (profile.pdMode === 'dual') {
        if (Number(profile.pdRight) < 22 || Number(profile.pdRight) > 40) errors.pdRight = 'Right PD is invalid.';
        if (Number(profile.pdLeft) < 22 || Number(profile.pdLeft) > 40) errors.pdLeft = 'Left PD is invalid.';
      } else if (Number(profile.pdSingle) < 46 || Number(profile.pdSingle) > 79) {
        errors.pdSingle = 'PD is invalid.';
      }
    }
    return errors;
  }

  function typeLabel(type) {
    return TYPE_LABELS[type] || 'Prescription';
  }

  function formatDate(value) {
    var raw = trim(value);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
    var date = new Date(raw + 'T00:00:00');
    if (isNaN(date.getTime())) return raw;
    try {
      return new Intl.DateTimeFormat(undefined, { year: 'numeric', month: 'short', day: 'numeric' }).format(date);
    } catch (error) {
      return raw;
    }
  }

  function safeStore(value) {
    pendingCache = value;
    try {
      if (value) window.sessionStorage.setItem(PENDING_KEY, JSON.stringify(value));
      else window.sessionStorage.removeItem(PENDING_KEY);
    } catch (error) {}
  }

  function readStored() {
    if (pendingCache) return pendingCache;
    try {
      var raw = window.sessionStorage.getItem(PENDING_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.profile) return null;
      if (parsed.expiresAt && Date.now() > Number(parsed.expiresAt)) {
        window.sessionStorage.removeItem(PENDING_KEY);
        return null;
      }
      pendingCache = parsed;
      return parsed;
    } catch (error) {
      return null;
    }
  }

  function peekPending() {
    var stored = readStored();
    return stored && stored.profile ? normalizeProfile(stored.profile) : null;
  }

  function consumePending(expectedId) {
    var profile = peekPending();
    if (expectedId && profile && profile.id !== expectedId) return profile;
    safeStore(null);
    document.dispatchEvent(new CustomEvent('es:saved-rx:pending-cleared'));
    return profile;
  }

  function safeAccessStore(value) {
    accessCache = value;
    try {
      if (value) window.sessionStorage.setItem(ACCESS_KEY, JSON.stringify(value));
      else window.sessionStorage.removeItem(ACCESS_KEY);
    } catch (error) {}
  }

  function readStorefrontAccess() {
    if (accessCache && accessCache.code && (!accessCache.expiresAt || Date.now() < Number(accessCache.expiresAt))) return accessCache;
    try {
      var raw = window.sessionStorage.getItem(ACCESS_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !/^[A-Za-z0-9_-]{40,120}$/.test(trim(parsed.code))) return null;
      if (parsed.expiresAt && Date.now() >= Number(parsed.expiresAt)) {
        window.sessionStorage.removeItem(ACCESS_KEY);
        return null;
      }
      accessCache = parsed;
      return parsed;
    } catch (error) {
      return null;
    }
  }

  function captureStorefrontAccess() {
    try {
      var url = new URL(window.location.href);
      var code = trim(url.searchParams.get('es_rx_access'));
      if (!/^[A-Za-z0-9_-]{40,120}$/.test(code)) return null;
      safeAccessStore({ code: code, receivedAt: Date.now(), expiresAt: Date.now() + 10 * 60 * 1000 });
      url.searchParams.delete('es_rx_access');
      window.history.replaceState(window.history.state, document.title, url.href);
      document.dispatchEvent(new CustomEvent('es:saved-rx:access-ready', { detail: { code: code } }));
      return code;
    } catch (error) {
      return null;
    }
  }

  function accessCode() {
    var stored = readStorefrontAccess();
    return stored && stored.code ? trim(stored.code) : '';
  }

  function withStorefrontAccess(value) {
    var raw = trim(value);
    var code = accessCode();
    if (!raw || !code) return raw;
    try {
      var url = new URL(raw, window.location.origin);
      url.searchParams.set('es_rx_access', code);
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return raw + (raw.indexOf('?') > -1 ? '&' : '?') + 'es_rx_access=' + encodeURIComponent(code);
    }
  }

  function sanitizeReturnUrl(value) {
    try {
      var url = new URL(value || window.location.href, window.location.origin);
      if (url.origin !== window.location.origin) return window.location.href;
      url.searchParams.delete('es_rx_code');
      url.searchParams.delete('es_rx_access');
      url.searchParams.delete('esSavedRxPicker');
      return url.href;
    } catch (error) {
      return window.location.href;
    }
  }

  function buildLensBuilderReturnUrl(value, type) {
    var safe = sanitizeReturnUrl(value || window.location.href);
    try {
      var url = new URL(safe, window.location.origin);
      var normalizedType = trim(type);
      url.searchParams.set('openLensBuilder', '1');
      if (ALLOWED_TYPES.indexOf(normalizedType) > -1) url.searchParams.set('esSavedRxType', normalizedType);
      else url.searchParams.delete('esSavedRxType');
      return url.href;
    } catch (error) {
      return safe;
    }
  }

  function buildAccountPickerUrl(options) {
    var base = accountPageUrl();
    if (!base) return '';
    var opts = options || {};
    try {
      var url = new URL(base, window.location.origin);
      var normalizedType = trim(opts.type);
      url.searchParams.set('mode', 'select');
      if (ALLOWED_TYPES.indexOf(normalizedType) > -1) url.searchParams.set('type', normalizedType);
      url.searchParams.set('return_to', buildLensBuilderReturnUrl(opts.returnUrl || window.location.href, normalizedType));
      return url.href;
    } catch (error) {
      return base;
    }
  }

  function buildAccountBridgeUrl(options) {
    var base = accountPageUrl();
    if (!base) return '';
    var opts = options || {};
    try {
      var url = new URL(base, window.location.origin);
      var normalizedType = trim(opts.type);
      url.searchParams.set('mode', 'storefront_bridge');
      if (ALLOWED_TYPES.indexOf(normalizedType) > -1) url.searchParams.set('type', normalizedType);
      url.searchParams.set('return_to', buildLensBuilderReturnUrl(opts.returnUrl || window.location.href, normalizedType));
      return url.href;
    } catch (error) {
      return base;
    }
  }

  function openBridge(options) {
    if (!isEnabled()) return false;
    var url = buildAccountBridgeUrl(options);
    if (!url) return false;
    window.location.assign(url);
    return true;
  }

  function openPicker(options) {
    if (!isEnabled()) return false;
    var url = buildAccountPickerUrl(options);
    if (!url) return false;
    window.location.assign(url);
    return true;
  }

  function manageUrl() {
    return accountPageUrl();
  }

  function clearPrescriptionListCache() {
    listCache = null;
    listCacheAt = 0;
  }

  function listPrescriptions(options) {
    var opts = options || {};
    var force = opts.force === true;
    if (!isEnabled()) return Promise.reject(new Error('Saved prescriptions are not enabled.'));
    if (!force && Array.isArray(listCache) && Date.now() - listCacheAt < LIST_CACHE_MS) {
      return Promise.resolve(listCache.slice());
    }
    if (listPromise) return listPromise;

    listPromise = fetch(withStorefrontAccess(proxyBase() + '/v1/prescriptions'), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      return response.text().then(function (text) {
        var payload = {};
        try { payload = text ? JSON.parse(text) : {}; } catch (error) {}
        if (!response.ok) {
          var requestError = new Error(payload.error || 'Saved prescriptions are temporarily unavailable.');
          requestError.status = response.status;
          if (response.status === 410) safeAccessStore(null);
          throw requestError;
        }
        var rows = Array.isArray(payload.prescriptions) ? payload.prescriptions : [];
        var profiles = rows.map(normalizeProfile).filter(function (profile) {
          return profile && profile.id && !Object.keys(validateProfile(profile)).length;
        }).sort(function (left, right) {
          return Number(!!right.isDefault) - Number(!!left.isDefault);
        });
        listCache = profiles;
        listCacheAt = Date.now();
        return profiles.slice();
      });
    }).finally(function () {
      listPromise = null;
    });
    return listPromise;
  }

  function fetchPrescriptionFile(profile) {
    var saved = normalizeProfile(profile);
    var errors = validateProfile(saved);
    if (saved.method !== 'upload' || !saved.file || errors.file) {
      return Promise.reject(new Error('The saved prescription file is unavailable.'));
    }
    return fetch(withStorefrontAccess(proxyBase() + '/v2/prescriptions/' + encodeURIComponent(saved.id) + '/file'), {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: saved.file.mimeType || 'application/octet-stream' }
    }).then(function (response) {
      if (!response.ok) {
        return response.text().then(function (text) {
          var payload = {};
          try { payload = text ? JSON.parse(text) : {}; } catch (error) {}
          var requestError = new Error(payload.error || 'The saved prescription file could not be loaded.');
          requestError.status = response.status;
          throw requestError;
        });
      }
      return response.blob();
    }).then(function (blob) {
      var type = saved.file.mimeType || blob.type || 'application/octet-stream';
      try {
        return new File([blob], saved.file.name || 'prescription', { type: type, lastModified: Date.now() });
      } catch (error) {
        blob.name = saved.file.name || 'prescription';
        blob.lastModified = Date.now();
        return blob;
      }
    });
  }

  function cleanHandoffUrl() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('es_rx_code')) return;
      url.searchParams.delete('es_rx_code');
      window.history.replaceState(window.history.state, document.title, url.href);
    } catch (error) {}
  }

  function redeemHandoff() {
    if (!isEnabled()) return Promise.resolve(null);
    var code = '';
    var reorderHandoff = false;
    try {
      var currentUrl = new URL(window.location.href);
      code = trim(currentUrl.searchParams.get('es_rx_code'));
      reorderHandoff = currentUrl.searchParams.get('es_reorder') === '1';
    } catch (error) {}
    if (!/^[A-Za-z0-9_-]{32,160}$/.test(code)) return Promise.resolve(null);
    if (redeemPromise) return redeemPromise;

    redeemPromise = fetch(proxyBase() + '/v1/handoff/redeem?code=' + encodeURIComponent(code), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      return response.text().then(function (text) {
        var payload = {};
        try { payload = text ? JSON.parse(text) : {}; } catch (error) {}
        if (!response.ok || !payload.prescription) {
          throw new Error(payload.error || 'The selected prescription could not be restored. Please choose it again.');
        }
        var profile = normalizeProfile(payload.prescription);
        var errors = validateProfile(profile);
        if (Object.keys(errors).length) throw new Error('The selected prescription could not be validated.');
        safeStore({
          profile: profile,
          receivedAt: Date.now(),
          expiresAt: Date.now() + 30 * 60 * 1000
        });
        cleanHandoffUrl();
        document.dispatchEvent(new CustomEvent('es:saved-rx:handoff', { detail: { profile: profile } }));
        return profile;
      });
    }).catch(function (error) {
      cleanHandoffUrl();
      var message = reorderHandoff
        ? 'The original order details could not be restored. Please return to your order and try Reorder again.'
        : (error && error.message ? error.message : 'The selected prescription could not be restored. Please choose it again.');
      document.dispatchEvent(new CustomEvent('es:saved-rx:handoff-error', {
        detail: { message: message, source: reorderHandoff ? 'order_reorder' : 'saved_prescription' }
      }));
      return null;
    }).finally(function () {
      redeemPromise = null;
    });
    return redeemPromise;
  }

  var api = {
    config: CONFIG,
    enabled: isEnabled,
    accountPageUrl: accountPageUrl,
    manageUrl: manageUrl,
    buildAccountPickerUrl: buildAccountPickerUrl,
    buildAccountBridgeUrl: buildAccountBridgeUrl,
    buildLensBuilderReturnUrl: buildLensBuilderReturnUrl,
    openPicker: openPicker,
    openBridge: openBridge,
    accessCode: accessCode,
    listPrescriptions: listPrescriptions,
    fetchPrescriptionFile: fetchPrescriptionFile,
    uploadOrderFile: uploadOrderFile,
    createOrderFileFromSaved: createOrderFileFromSaved,
    claimOrderFile: claimOrderFile,
    deleteOrderFile: deleteOrderFile,
    normalizeOrderFile: normalizeOrderFile,
    clearPrescriptionListCache: clearPrescriptionListCache,
    redeemHandoff: redeemHandoff,
    peekPending: peekPending,
    consumePending: consumePending,
    normalizeProfile: normalizeProfile,
    validateProfile: validateProfile,
    typeLabel: typeLabel,
    formatDate: formatDate
  };

  window.ESSavedPrescriptions = api;

  function boot() {
    captureStorefrontAccess();
    redeemHandoff();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})(window, document);
